module.exports = __webpack_public_path__ + "static/media/Genesect_gaussian2.6c9c06f4.png";